import { get } from 'lodash';
import { createSelector } from 'reselect';
import { WellGuideLinkVariants } from '@zocdoc/components/src/Layout/Header/constants';
import { useDropdownHeaderChevron } from '../../Home/experiments/insurancePickerUseDropdownHeaderChevron';
import isZocdocBrand from '../../utils/isZocdocBrand';
import { getThemeParameters } from '../theme';
import { AB_KEY } from './constants';
import {
    PINA_HAMBURGER_MENU_WELL_GUIDE_LINK,
    PINA_PROVIDER_AVAILABILITY_TOOLTIP,
    SALP_BLOCK,
    SHOW_FACETED_SEARCHBAR,
    SHOW_FIND_SIMILAR_DOCTORS,
    SHOW_NEW_SIDE_BAR,
    SHOW_REVIEW_COUNT,
    TELEHEALTH_LINK_TO_BOOKING,
    TELEHEALTH_LINK_TO_PROFILE,
    VARIANT_ON,
    SPO_USE_SPOOM,
    PINA_INSURANCE_PICKER_PERSIST_CHOSEN_CARRIER,
    PINA_PROFILE_CHECK_INSURANCE_MODAL,
} from './experiments';

export const getABParameters = state => state[AB_KEY];

export const showFindSimilarDoctors = createSelector(
    [getABParameters, getThemeParameters],
    (ab, theme) => {
        return ab[SHOW_FIND_SIMILAR_DOCTORS.experimentId] === VARIANT_ON
            && isZocdocBrand(theme.directoryId);
    }
);

export const showFacetedSearchBar = createSelector(
    [getABParameters, getThemeParameters],
    (ab, theme) => {
        return ab[SHOW_FACETED_SEARCHBAR.experimentId] === VARIANT_ON
            && isZocdocBrand(theme.directoryId);
    },
);

export const showReviewCount = createSelector(
    [getABParameters, getThemeParameters],
    (ab, theme) => {
        return ab[SHOW_REVIEW_COUNT.experimentId] === VARIANT_ON
            && isZocdocBrand(theme.directoryId);
    },
);

export const showSalpBlock = createSelector(
    [getABParameters],
    ab => ab[SALP_BLOCK.experimentId] === VARIANT_ON,
);

export const shouldPersistChosenCarrier = createSelector(
    getABParameters,
    ab => ab[PINA_INSURANCE_PICKER_PERSIST_CHOSEN_CARRIER.experimentId] === VARIANT_ON,
);

export const useChevronDropdownHeader = createSelector(
    getABParameters,
    ab => useDropdownHeaderChevron(ab),
);

export const shouldLinkTelehealthProfile = createSelector(
    [getABParameters],
    ab => ab[TELEHEALTH_LINK_TO_PROFILE.experimentId] === VARIANT_ON,
);

export const getWellGuideLinkVariantFromProps = ({ ab }) =>
    get(ab, PINA_HAMBURGER_MENU_WELL_GUIDE_LINK.experimentId, WellGuideLinkVariants.OFF);

export const getWellGuideLinkVariant = createSelector(
    getABParameters,
    ab => ab[PINA_HAMBURGER_MENU_WELL_GUIDE_LINK.experimentId],
);

export const shouldLinkTelehealthBooking = createSelector(
    [getABParameters],
    ab => ab[TELEHEALTH_LINK_TO_BOOKING.experimentId] === VARIANT_ON,
);

export const shouldShowNewSidebar = createSelector(
    [getABParameters],
    ab => ab[SHOW_NEW_SIDE_BAR.experimentId] === VARIANT_ON,
);

export const shouldUseSpoom = createSelector(
    [getABParameters],
    ab => ab[SPO_USE_SPOOM.experimentId] === VARIANT_ON,
);

export const shouldDisplayProviderAvailabilityTooltip = createSelector(
    [getABParameters],
    ab => ab[PINA_PROVIDER_AVAILABILITY_TOOLTIP.experimentId] === VARIANT_ON,
);

export const shouldShowCheckInsuranceModal = createSelector(
    [getABParameters],
    ab => ab[PINA_PROFILE_CHECK_INSURANCE_MODAL.experimentId] === VARIANT_ON,
);
